import React, { useEffect, useState } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import ProdutoModal from './modals/Produto';
import EntradaProdutoModal from './modals/EntradaProduto';
import SaidaProdutoModal from './modals/SaidaProduto';
import HistoricoProdutoModal from './modals/HistoricoProduto';

import { FaPlus, FaEdit, FaFilter, FaTrashAlt, FaArrowDown, FaArrowUp, FaHistory } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';

const Produtos = () => {
  const [error, setError] = useState(null);

  const [fornecedores, setFornecedores] = useState([]);
  const [localEstoque, setLocalEstoque] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [userType, setUserType] = useState('');

  const [selectedProduto, setSelectedProduto] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEntradaModalOpen, setIsEntradaModalOpen] = useState(false);
  const [isSaidaModalOpen, setIsSaidaModalOpen] = useState(false);
  const [isHistoricoModalOpen, setIsHistoricoModalOpen] = useState(false);
  const [selectedProdutoHistorico, setSelectedProdutoHistorico] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const getLocalEstoque = async () => {
    try {
      const response = await api.get(`/localEstoques?page=1&limit=200`);

      setLocalEstoque(response.data.records || []);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar a lista de locais de estoque.');
    }
  };

  const getFornecedores = async () => {
    try {
      const response = await api.get(`/pessoas/fornecedores?page=1&limit=200`);

      setFornecedores(response.data.fornecedores || []);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar a lista de fornecedores.');
    }
  };

  const fetchProdutos = async (currentPage) => {
    try {
      Swal.fire({
        title: "Carregando...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      const response = await api.get(`/produtos?page=${currentPage}&limit=${limit}&nome=${filtroNome}`);

      Swal.close();
      setProdutos(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
    } catch (err) {
      Swal.close();
      setError('Erro ao carregar a lista de produtos.');
    }
  };

  useEffect(() => {
    const fetchUserType = async () => {
      try {
        const userDataArmazenado = localStorage.getItem('userData');
        
        if (userDataArmazenado) {
          const userData = JSON.parse(userDataArmazenado);
          
          if (userData.unidade_designacao_id && userData.gestora_designacao_id) {
            setUserType('colaborador');
          } else if (userData.gestora_designacao_id) {
            setUserType('gestor');
          } else {
            setUserType('master');
          }
          return;
        }
      } catch (error) {
        setUserType('colaborador');
      }
    };
    
    const fetchData = async () => {
      await fetchUserType();
      if (!fornecedores.length) await getFornecedores();
      if (!localEstoque.length) await getLocalEstoque();
      fetchProdutos(currentPage);
    };

    fetchData();
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddProdutos = () => {
    setSelectedProduto(null);
    setIsModalOpen(true);
  };

  const handleEditProdutos = (produto) => {
    setSelectedProduto(produto);
    setIsModalOpen(true);
  };

  const handleRegistrarEntrada = () => {
    setIsEntradaModalOpen(true);
  };

  const handleRegistrarSaida = () => {
    setIsSaidaModalOpen(true);
  };

  const handleVerHistorico = (produto) => {
    setSelectedProdutoHistorico(produto);
    setIsHistoricoModalOpen(true);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchProdutos(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
  };


  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Produtos</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-lg-8 col-md-12 col-12">
              <div className="d-flex flex-column flex-sm-row gap-2">
                {(userType === 'master' || userType === 'gestor') && (
                  <button className="btn btn-outline-primary flex-fill flex-sm-grow-0" onClick={handleAddProdutos}>
                    <FaPlus className="me-1" />
                    <span className="d-none d-sm-inline">Adicionar </span>Produto
                  </button>
                )}
                <button className="btn btn-outline-success flex-fill flex-sm-grow-0" onClick={handleRegistrarEntrada}>
                  <FaArrowUp className="me-1" />
                  <span className="d-none d-sm-inline">Registrar </span>Entrada
                </button>
                <button className="btn btn-outline-danger flex-fill flex-sm-grow-0" onClick={handleRegistrarSaida}>
                  <FaArrowDown className="me-1" />
                  <span className="d-none d-sm-inline">Registrar </span>Saída
                </button>
              </div>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-4 col-md-6 col-12">
              <label className="form-label fw-bold">Nome do Produto</label>
              <input
                type="text"
                placeholder="Digite o nome do produto"
                autoComplete="off"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-8 col-md-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Produto</th>
                    <th className="text-nowrap">Valor de Venda</th>
                    <th className="text-nowrap">Estoque Atual</th>
                    <th className="text-nowrap">Estoque Mínimo</th>
                    <th>Marca</th>
                    <th>Categoria</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {produtos.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        Nenhum produto encontrado.
                      </td>
                    </tr>
                  ) : (
                    produtos.map((produto) => (
                      <tr key={produto.id_produto}>
                        <td className="text-nowrap">{produto.nome}</td>
                        <td className="text-nowrap">{parseFloat(produto.valor_venda).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                        <td className="text-nowrap">{produto.estoque_atual}</td>
                        <td className="text-nowrap">{produto.estoque_minimo}</td>
                        <td className="text-nowrap">{produto.marca}</td>
                        <td className="text-nowrap">{produto.categoria}</td>
                        <td className="text-center text-nowrap">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditProdutos(produto)}
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn btn-custom-secondary btn-sm ms-3"
                            onClick={() => handleVerHistorico(produto)}
                          >
                            <FaHistory />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        {isModalOpen && (
          <ProdutoModal
            produto={selectedProduto}
            fornecedores={fornecedores}
            localEstoque={localEstoque}
            onClose={() => setIsModalOpen(false)}
            onProdutoAtualizado={() => fetchProdutos(currentPage)}
          />
        )}

        {isEntradaModalOpen && (
          <EntradaProdutoModal
            onClose={() => setIsEntradaModalOpen(false)}
            onEntradaRegistrada={() => fetchProdutos(currentPage)}
          />
        )}

        {isSaidaModalOpen && (
          <SaidaProdutoModal
            onClose={() => setIsSaidaModalOpen(false)}
            onSaidaRegistrada={() => fetchProdutos(currentPage)}
          />
        )}

        {isHistoricoModalOpen && (
          <HistoricoProdutoModal
            produto={selectedProdutoHistorico}
            onClose={() => setIsHistoricoModalOpen(false)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Produtos;
